import {
  Badge,
  Button,
  Col,
  DatePicker,
  Descriptions,
  Form,
  List,
  Modal,
  Select,
  Tag,
  Typography,
  Alert,
} from "antd";
import React, { useEffect, useState } from "react";
import { IBusinessFull } from "../../../../../interfaces/businessFull.interface";
import {
  UserOutlined,
  FileOutlined,
  DownloadOutlined,
  CheckCircleFilled,
} from "@ant-design/icons";
import Loader from "../../../../common/loader/Loader";
import {
  getBusinessFilesThunk,
  getBusinessUsersThunk,
  selectCurrentBusiness,
  selectCurrentBusinessFiles,
  selectCurrentBusinessUsers,
  selectIsLoadingBusinessUsers,
} from "../../../businessesSlice";
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
import { downloadFile } from "../../../../../utils/downloadFile";
import { extractDeviceLogs } from "../../../businessesApi";
import { LocalDateAsUTC } from "../../../../../utils/LocalDateAsUTC";
import { error } from "console";
import dayjs from "dayjs";
import CustomDateRangePicker from "../../../../common/custom-date-range-picker/CustomDateRangePicker";
const { Paragraph } = Typography;
interface IPropsExtractLogsFormModel {
  visible: boolean;
  setVisible: any;
  deviceId: string;
}

const extractLogsFormFieldLayout = {
  labelCol: { span: 5 },
  wrapperCol: { span: 12 },
};
export default function ExtractLogsFormModal({
  deviceId,
  visible,
  setVisible,
}: IPropsExtractLogsFormModel) {
  const business = useAppSelector(selectCurrentBusiness);
  const [url, setUrl] = useState<string>();
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [error, setError] = useState("");
  const handleSubmit = async (
    values: { fileFormat: "zip" | "txt" } & { dateRange?: dayjs.Dayjs[] }
  ) => {
    try {
      setError("");
      setUrl(undefined);
      setLoading(true);

      console.log("extractDeviceLogs");

      console.log("values", values);
      if (!values.dateRange || values.dateRange.length !== 2) {
        setError("Please select a valid date range");
        return;
      }

      const [start, end] = values.dateRange;
      const startDate = start.millisecond(0).second(0);
      const endDate = end.millisecond(999).second(59);
      let startDateISO = LocalDateAsUTC.getISOFromDate(startDate.toDate());
      let endDateISO = LocalDateAsUTC.getISOFromDate(endDate.toDate());
      const results = await extractDeviceLogs({
        deviceId,
        businessId: business._id,
        start: startDateISO,
        end: endDateISO,
        fileFormat: values?.fileFormat || "zip",
      });

      setUrl(results?.url || "");
    } catch (error) {
      console.log("error", error);
      setError(
        error instanceof Error
          ? error.message
          : "An error occurred while extracting logs"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setVisible(false);
    resetState();
  };
  const resetState = () => {
    setUrl(undefined);
    setLoading(false);
    setError("");
  };

  return (
    <Modal
      visible={visible}
      title={`${business?.businessName} - ${deviceId?.slice(
        -6
      )} -  Extract Logs`}
      onCancel={handleCancel}
      footer={null}
      width={500}
    >
      <Form onFinish={handleSubmit} form={form}>
        <Form.Item
          name="dateRange"
          label={"Date Range"}
          labelCol={{ ...extractLogsFormFieldLayout.labelCol }}
          labelAlign="left"
          rules={[
            {
              required: true,
              message: "Please select a date range",
            },
          ]}
        >
          <CustomDateRangePicker placeholder={["Start Date", "End Date"]} />
        </Form.Item>
        <Form.Item
          name="fileFormat"
          label={"File Format"}
          initialValue={"zip"}
          labelCol={{ ...extractLogsFormFieldLayout.labelCol }}
          labelAlign="left"
          hidden
        >
          <Select
            options={[
              { value: "zip", label: ".zip" },
              { value: "txt", label: ".txt" },
            ]}
          ></Select>
        </Form.Item>

        <Form.Item>
          <Button
            style={{ float: "right" }}
            type="primary"
            htmlType="submit"
            loading={loading}
          >
            Extract logs
          </Button>
        </Form.Item>
      </Form>
      {/* {isLoadingBusinessUsers && <Loader text="Fetching Business Users" />} */}

      {url && url?.length > 0 && (
        <div>
          <CheckCircleFilled style={{ margin: "0 10px", color: "green" }} />
          <span>
            Uploading might take a few minutes. To view click
            <a style={{ marginLeft: "5px" }} href={url} target="_blank">
              here
            </a>
            .
          </span>
        </div>
      )}

      {error && error?.length > 0 && (
        <Alert
          message="Error"
          description={error}
          type="error"
          showIcon
          style={{ marginTop: 16 }}
        />
      )}
    </Modal>
  );
}
